import React from 'react';
const DistrictContext = React.createContext(null);
const emptyCommunity = () => ({
    id: '',
    title: '76UNBOXED',
    subdomain: '',
    email: '',
    phone: '',
    fax: '',
    kind: 'root',
    subdomainEnabled: true,
    logoUrl: null,
    logoAttachmentId: null,
    address: '',
    facebookUrl: '',
    twitterUrl: '',
    instagramUrl: '',
    linkedinUrl: '',
    youtubeUrl: '',
    area: null,
});
const DistrictProvider = (props) => {
    const [district, setDistrict] = React.useState(emptyCommunity);
    React.useEffect(() => {
        let cancelled = false;
        props.districtPromise.then(result => {
            if (!cancelled) {
                setDistrict(result);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [props.districtPromise]);
    const updateDistrict = React.useCallback((updates) => {
        setDistrict(prev => (Object.assign(Object.assign({}, prev), updates)));
    }, []);
    return React.createElement(DistrictContext.Provider, {
        value: {
            district,
            updateDistrict,
            displaySettings: props.displaySettings,
            banners: props.banners,
        },
    }, props.children);
};
export const useDistrict = () => {
    const ctx = React.useContext(DistrictContext);
    if (!ctx) {
        throw new Error('useDistrict must be used within DistrictProvider');
    }
    return ctx;
};
export const useCommunity = () => {
    try {
        return useDistrict();
    }
    catch (_a) {
        return {
            district: emptyCommunity(),
            updateDistrict: () => { },
            displaySettings: {},
            banners: [],
        };
    }
};
export { DistrictProvider };
export default useDistrict;
